import { Link as Link } from 'react-router-dom'
import React from 'react'

import logo from '@public/logo.svg'

export interface TitleProps {
  collapsed: boolean
}

export const Title: React.FC<TitleProps> = ({ collapsed }) => (
  <Link to="/" style={{ display: 'block', height: 'fit-content' }}>
    {collapsed ? (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 'fit-content',
        }}
      >
        <img
          src={logo}
          alt="autorizconstruction"
          height={65.5}
          width={65.5}
          style={{
            margin: '6px auto',
            padding: '6px 0',
          }}
        />
      </div>
    ) : (
      <img
        src={logo}
        alt="autorizconstruction"
        width={200}
        height={200}
        style={{
          padding: '12px 12px',
        }}
      />
    )}
  </Link>
)
